import { WorkloadOptimizationAgentStatus } from '@cast/types';

import { useWorkloadOptimizationAgentStatusQuery } from 'hooks/queries/workload-optimization';

import { useWasEnabled } from './useWasEnabled';
import { OnboardingPhase2HookProps } from '../types';

export const useWasWorkloadAutoscalerEnabled = ({
  clusterId,
  onSuccess,
  onError,
  enabled,
}: OnboardingPhase2HookProps): boolean => {
  const { data, error } = useWorkloadOptimizationAgentStatusQuery({
    clusterId,
    refetchInterval: enabled ? 20_000 : false,
    enabled,
  });
  const isWoopInstalled =
    data?.status === WorkloadOptimizationAgentStatus.RUNNING;

  useWasEnabled({
    currentState: isWoopInstalled,
    onSuccess: onSuccess,
    onError: onError,
    error,
    enabled,
  });

  return isWoopInstalled;
};
